import { render, staticRenderFns } from "./InfoMinorSvg.vue?vue&type=template&id=135dc786&"
import script from "./InfoMinorSvg.vue?vue&type=script&lang=ts&"
export * from "./InfoMinorSvg.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports